<style scoped>
    .image-container{
        display: inline-block;
        vertical-align: top;
        min-width: 80px;
        margin-right: 5px;
    }
    .image-container:hover{
        cursor: pointer;
        box-shadow: 0 1px 3px rgba(55,55,55,.3);
    }
    .image-container img{
        width: 100%;
    }
    .preview-image{
        max-width: 100%;
    }
</style>
<template>
  <div
    class="image-container"
    :style="widthStyle"
    @click="previewImage"
  >
    <img
      v-if="src"
      :src="src"
    >
    <Modal
      v-model="config.modal"
      transfer
      width="width"
      ok-text="关闭"
      cancel-text=""
      :closable="false"
      fullscreen
    >
      <div class="text-center">
        <img
          v-if="src"
          class="preview-image"
          :src="src"
        >
      </div>
    </Modal>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  export default {
    props: {
      src: {
        type: String
      },
      width: {
        type: [String, Number],
        'default': 100
      }
    },
    data() {
      return {
        config: {
          modal: false
        }
      }
    },
    computed: {
      widthStyle() {
        const width_str = this.width.toString();
        const width = parseInt(this.width);
        if (width_str.indexOf('%') !== -1) {
          return {width: width_str};
        } else {
          return {width: width + 'px'};
        }
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      previewImage() {
        this.config.modal = true;
      }
    }
  }
</script>
